// Admin seller registration step 3: toggle mandatory_field for trusted seller bank / Paytrail inputs (checkMandatory)
window.syncSellerStep3MandatoryFields = function() {
  var form = $('form.pre-load-form');
  if (form.length === 0) {
    return;
  }
  // Seller registration step 3 has TRUSTED_SELLER / ONE_TIME_SELLER radios; My Settings has none.
  var trusted;
  if (form.find('input.seller_user_type').length) {
    trusted = form.find('input.seller_user_type:checked').val() === 'TRUSTED_SELLER';
  } else {
    var $trustedInfo = form.find('#trusted_seller_info');
    trusted = $trustedInfo.length > 0 && !$trustedInfo.hasClass('hide');
  }
  var paytrailCheckbox = form.find('input[name="user[has_paytrail_service]"][type="checkbox"]');
  var paytrailOn = paytrailCheckbox.length ? paytrailCheckbox.is(':checked') : false;

  form.find('.seller-step3-account-input').each(function() {
    var $el = $(this);
    var role = $el.attr('data-seller-step3-mandatory');
    var need = false;
    // Bank / Paytrail details are required only when Trusted seller AND Paytrail service is Yes
    if (role === 'bank' || role === 'account' || role === 'paytrail') {
      need = trusted && paytrailOn;
    }
    if (need) {
      $el.addClass('mandatory_field');
    } else {
      $el.removeClass('mandatory_field');
      var wrap = $el.closest('.form-group-label');
      wrap.removeClass('has-error');
      wrap.find('small.help-block.text-red').remove();
      wrap.find('i.form-control-feedback.fa-remove').remove();
    }
  });
  var showTrustedPaytrail = trusted && paytrailOn;
  form.find('.seller-trusted-paytrail-hint').toggleClass('hide', !showTrustedPaytrail);
  form.find('.seller-step3-required-star').toggleClass('hide', !showTrustedPaytrail);
  if (typeof validateAndToggleButtons === 'function') {
    validateAndToggleButtons(form);
  }
};

$(document).ready(function(){

  $(document).on("click", ".update_online_auction_price_list", function(){
    var price_step_count = $("#price_step_count").val();
    if($(this).val() == "true"){
      for (i = 1; i <= price_step_count; i += 1) {
        $('#input_add_min_price_'+i).prop('disabled', false);
        $('#input_add_max_price_'+i).prop('disabled', false);
        $('#input_add_ad_price_'+i).prop('disabled', false);
      }
    }else{
      for (i = 1; i <= price_step_count; i += 1) {
        $('#input_add_min_price_'+i).prop('disabled', true);
        $('#input_add_max_price_'+i).prop('disabled', true);
        $('#input_add_ad_price_'+i).prop('disabled', true);
      }
    }
  });

  $(document).on("click", ".update_auction_notice_price_list", function(){
    if($(this).val() == "true"){
      $('#user_auction_notice_price_list').prop('disabled', false);
    }else{
      $('#user_auction_notice_price_list').prop('disabled', true);
    }
  });

  $(document).on("click", ".update_sales_ad_price_list", function(){
    if($(this).val() == "true"){
      $('#sales_ad_one_period').prop('disabled', false);
      $('#sales_ad_two_period').prop('disabled', false);
      $('#sales_ad_three_period').prop('disabled', false);
      $('#sales_ad_one_price').prop('disabled', false);
      $('#sales_ad_two_price').prop('disabled', false);
      $('#sales_ad_three_price').prop('disabled', false);
    }else{
      $('#sales_ad_one_price').prop('disabled', true);
      $('#sales_ad_two_price').prop('disabled', true);
      $('#sales_ad_three_price').prop('disabled', true);
      $('#sales_ad_one_period').prop('disabled', true);
      $('#sales_ad_two_period').prop('disabled', true);
      $('#sales_ad_three_period').prop('disabled', true);
    }
  });

  $(document).on("click", ".active_private", function(){
    $('.active_private').addClass('btn-primary');
    $('.active_company').removeClass('btn-primary');
    $("#user_customer_type").val("PRIVATE");
    $( "#company_info" ).addClass( "hide" );
    $( "#company_other_info" ).addClass( "hide" );
    $( "#private_info" ).removeClass( "hide" )
    if (typeof window.syncMonetSignupSubmitButton === 'function') {
      window.syncMonetSignupSubmitButton();
    }
  });

  $(document).on("click", ".active_company", function(){
    $('.active_company').addClass('btn-primary');
    $('.active_private').removeClass('btn-primary');
    $("#user_customer_type").val("COMPANY");
    $( "#private_info" ).addClass( "hide" );
    $( "#company_info" ).removeClass( "hide" );
    $( "#company_other_info" ).removeClass( "hide" );
    if (typeof window.syncMonetSignupSubmitButton === 'function') {
      window.syncMonetSignupSubmitButton();
    }
  });

  $(document).on("click", ".seller_user_type", function(){
    if ($(this).val() == "ONE_TIME_SELLER") {
      $("#trusted_seller_info").addClass("hide");
      $("#trusted_seller_service_prices_info").addClass("hide");
      $("#paytrail_service_info").addClass("hide");
    } else {
      $("#trusted_seller_info").removeClass("hide");
      $("#trusted_seller_service_prices_info").removeClass("hide");
      if ($('input[name="user[has_paytrail_service]"][type="checkbox"]').is(':checked')) {
        $("#paytrail_service_info").removeClass("hide");
      } else {
        $("#paytrail_service_info").addClass("hide");
      }
    }
    if (window.syncSellerStep3MandatoryFields) {
      window.syncSellerStep3MandatoryFields();
    }
  });

  $(document).on("change", 'input[name="user[has_paytrail_service]"][type="checkbox"]', function() {
    if ($(this).is(':checked')) {
      $('#paytrail_service_info').removeClass('hide');
    } else {
      $('#paytrail_service_info').addClass('hide');
    }
    $('#trusted_seller_info .switch').first().closest('.mb-3').removeClass('has-error').find('small.seller-paytrail-required').remove();
    if (window.syncSellerStep3MandatoryFields) {
      window.syncSellerStep3MandatoryFields();
    }
  });

  setTimeout(function() {
    if (window.syncSellerStep3MandatoryFields) {
      window.syncSellerStep3MandatoryFields();
    }
  }, 300);
  setTimeout(function() {
    if (window.syncSellerStep3MandatoryFields) {
      window.syncSellerStep3MandatoryFields();
    }
  }, 800);

  $(document).on('input change keyup', '.seller-step3-account-input', function() {
    var form = $(this).closest('form.pre-load-form');
    if (form.length && typeof validateAndToggleButtons === 'function') {
      validateAndToggleButtons(form);
    }
  });

  $('.img-wrap .close').on('click', function() {
      alert('remove picture: ');
  });

  $(document).on('click', '.show_image_loader', function(){
    $("#loader-image").show();
  });
});